import { useEffect } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";
import { useFastshiftSelector } from "@/state";
import { TABLE_IDS } from "@/state/constants";

export const useMigrationTicketsPageAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
    const { fireScreenEvent, fireTrackEvent } =
        useFireAnalyticsEvents(identityAttrs);

    const { selectedDomainOrg } = useFastshiftSelector((state) => ({
        selectedDomainOrg: state.selectedDomainOrg
    }));

    const { data: supportRequestsData } = useFastshiftSelector(
        (state) => state.supportRequests
    );

    const { data: customerDomainData } = useFastshiftSelector(
        (state) => state.customerDomain
    );

    const cachedTableControls = useFastshiftSelector(
        (state) => state.pageStateCache[TABLE_IDS.MIGRATION_TICKETS]
    );

    // Screen event on mount
    useEffect(() => {
        if (!identityAttrs) return;

        fireScreenEvent({
            name: sourceKey
        });
    }, [fireScreenEvent, sourceKey, identityAttrs]);

    // Track event when page data loads or pagination changes
    useEffect(() => {
        if (!identityAttrs || !selectedDomainOrg || !supportRequestsData) {
            return;
        }

        const planTicketList = supportRequestsData
            .slice(
                cachedTableControls.page * cachedTableControls.size,
                (cachedTableControls.page + 1) * cachedTableControls.size
            )
            .map((ticket) => ticket.supportTicketId);

        const orgCount = customerDomainData?.orgsWithAdminRole.length;

        fireTrackEvent({
            action: ActionKey.DISPLAYED,
            actionSubject: ActionSubjectKey.SECTION,
            actionSubjectId: ActionSubjectIdKey.MIGRATION_TICKETS_PAGE_DETAILS,
            source: sourceKey,
            attributes: {
                selectedOrgId: selectedDomainOrg.orgId,
                orgCount,
                planTicketCount: planTicketList.length,
                planTicketList
            }
        });
    }, [
        identityAttrs,
        selectedDomainOrg,
        supportRequestsData,
        cachedTableControls.page,
        cachedTableControls.size,
        customerDomainData,
        fireTrackEvent,
        sourceKey
    ]);
};
